module.exports = __webpack_public_path__ + "static/media/no_data.06262f39.svg";